import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconRedo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "10 10 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M27.6213 14.6213C28.0118 15.0118 28.0118 15.645 27.6213 16.0355L24.7929 18.864C24.4023 19.2545 23.7692 19.2545 23.3787 18.864C22.9881 18.4734 22.9881 17.8403 23.3787 17.4497L24.3281 16.5003H21.0858C17.2198 16.5003 14.0858 19.6343 14.0858 23.5003V27.5003C14.0858 28.0526 13.6381 28.5003 13.0858 28.5003C12.5335 28.5003 12.0858 28.0526 12.0858 27.5003V23.5003C12.0858 18.5297 16.1152 14.5003 21.0858 14.5003H24.6718L23.3787 13.2071C22.9881 12.8166 22.9881 12.1834 23.3787 11.7929C23.7692 11.4024 24.4023 11.4024 24.7929 11.7929L27.6213 14.6213Z",
		fill: "#E0E0E0"
	})
});
export default SvgIconRedo;
